import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "onramp-navigation" }
const _hoisted_2 = { class: "onramp-navigation side left" }
const _hoisted_3 = { class: "onramp-navigation-inner" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { class: "complete" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Services")
], -1)
const _hoisted_5 = ["disabled", "event"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Vehicle", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled", "event"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Register", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["disabled", "event"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Estimates", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["disabled", "event"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Book", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["disabled", "event"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Confirm", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "onramp-navigation side right" }
const _hoisted_21 = { class: "onramp-navigation-bottom text-center pt-2" }
const _hoisted_22 = { class: "current-step" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        name: "slide-up",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_ctx.showBackButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn back btn-circle",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, [
                _createVNode(_component_icon, { icon: ['fal', 'arrow-left'] })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("a", {
        disabled: !_ctx.isCompleted('vehicle'),
        class: _normalizeClass({ complete: _ctx.isCompleted('vehicle') }),
        event: _ctx.isCompleted('vehicle') ? 'click' : ''
      }, _hoisted_7, 10, _hoisted_5),
      _createElementVNode("a", {
        disabled: !_ctx.isCompleted('sign-up'),
        class: _normalizeClass({ complete: _ctx.isCompleted('sign-up') }),
        event: _ctx.isCompleted('sign-up') ? 'click' : ''
      }, _hoisted_10, 10, _hoisted_8),
      _createElementVNode("a", {
        disabled: !_ctx.isCompleted('estimate'),
        event: _ctx.isCompleted('estimate') ? 'click' : '',
        class: _normalizeClass({ complete: _ctx.isCompleted('estimate') })
      }, _hoisted_13, 10, _hoisted_11),
      _createElementVNode("a", {
        disabled: !_ctx.isCompleted('book'),
        event: _ctx.isCompleted('book') ? 'click' : '',
        class: _normalizeClass({ complete: _ctx.isCompleted('book') })
      }, _hoisted_16, 10, _hoisted_14),
      _createElementVNode("a", {
        disabled: !_ctx.isCompleted('confirm'),
        event: _ctx.isCompleted('confirm') ? 'click' : ''
      }, _hoisted_19, 8, _hoisted_17)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_Transition, {
        name: "slide-up",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_ctx.showCloseButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-circle btn-close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, [
                _createVNode(_component_icon, {
                  icon: ['fal', 'times'],
                  size: "lg"
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.currentStepLabel), 1)
    ])
  ]))
}